import { Box, Grid } from '@mui/material';
import RingMyPhoneMessageSettings from './RingMyPhoneMessageSettings';

const RingMyPhoneSettings = () => (
  <Box marginTop="16px">
    <Grid container spacing={2}>
      <Grid item md={6}>
        <RingMyPhoneMessageSettings />
      </Grid>
    </Grid>
  </Box>
);

export default RingMyPhoneSettings;
